import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="section-padding bg-background-100">
      <div className="container-wide">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于爱情岛旅行的热门问题，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${
                  openIndex === index ? 'rotate-180 text-primary-500' : 'text-foreground-400'
                }`}>
                  <i className="ri-arrow-down-s-line text-base"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}